export const careerProfileLabels = {
  workGoals: {
    title: "Work goals",
    index: 0,
    workGoals_1: {
      value: "workGoals_1",
      label:
        "What is your dream job? What kind of work have you always wanted to do?",
    },
    workGoals_2: {
      value: "workGoals_2",
      label: "What are your long-term career goals?",
    },
    workGoals_3: {
      value: "workGoals_3",
      label: "What type of job do you think you would like to have now?",
    },
    workGoals_4: {
      value: "workGoals_4",
      label: "What type of job(s) do you know that you would not want?",
    },
    workGoals_5: {
      value: "workGoals_5",
      label:
        "Do you know people who are working? What types of jobs? What do you think about those jobs?",
    },
    workGoals_6: {
      value: "workGoals_6",
      label:
        "Is there anything that worries you about going to work? Why do you want to work?",
    },
  },
  education: {
    title: "Education",
    index: 1,
    education_1: {
      value: "education_1",
      label: "Did you complete high school or earn a GED?",
    },
    education_1a: {
      value: "education_1a",
      label:
        "Would you be interested in earning your GED/high school equivalency diploma?",
    },
    education_2: {
      label:
        "Did you participate in vocational training classes in high school?",
      value: "education_2",
    },
    education_3: {
      label:
        "Have you ever completed an apprenticeship (i.e., plumbing, welding, electrician, etc.)?",
      value: "education_3",
    },
    education_3a: {
      label: "What year did you complete this apprenticeship?",
      value: "education_3a",
    },
    education_4: {
      label: "Did you ever complete any job-related training in the military?",
      value: "education_4",
    },
    education_4a: {
      label:
        "Please describe the training, including years and any certificates earned",
      value: "education_4a",
    },
    education_5: {
      label:
        "Do you have copies of the degrees, licenses, certificates that you have earned?",
      value: "education_5",
    },
    education_5a: {
      label: "Have the copies been provided to the specialist?",
      value: "education_5a",
    },
    education_6: {
      label:
        "Are you interested in earning a specific certificate, license, or degree for work?",
      value: "education_6",
    },
    education_6a: {
      label: "What type of job are you interested in obtaining?",
      value: "education_6a",
    },
    education_6b: {
      label: "What type of specific training/program would you like to pursue?",
      value: "education_6b",
    },
    education_6c: {
      label: "What is it about this field or job that interests you?",
      value: "education_6c",
    },
    education_6d: {
      label:
        "What do you know about the availability and occupational outlook for those jobs in this field/area?",
      value: "education_6d",
    },
    education_6e: {
      label: "When would you like to start an educational or training program?",
      value: "education_6e",
      type: "html",
      aux_value: "education_6e1",
      aux_type: "date",
    },
    education_6e1: {
      label: "",
      value: "education_6e1",
      skip: true,
    },
    education_6f: {
      label: "How long do you want to go to a school or training program?",
      value: "education_6f",
    },
    education_6g: {
      label: "What is your timeframe for completing education or training?",
      value: "education_6g",
    },
    education_6h: {
      label:
        "Would you be interested in visiting some local programs to learn about different degrees and certificates?",
      value: "education_6h",
    },
    education_6i: {
      label: "Are you interested in joining a trade union?",
      value: "education_6i",
    },
    education_6i1: {
      label: "Which type of trade union?",
      value: "education_6i1",
    },
    education_6i2: {
      label: "Do you know the requirements for joining the trade union?",
      value: "education_6i2",
    },
    education_6i3: {
      label: "Would you like to visit the union office to learn more?",
      value: "education_6i3",
    },
    education_6j: {
      label:
        "Please describe any other job training or educational opportunities that you would like to learn more about:",
      value: "education_6j",
    },
  },
  pastEducationExperiences: {
    title: "Past education experiences",
    index: 2,
    pastEducation_1: {
      value: "pastEducation_1",
      label: "Being called on in class",
    },
    pastEducation_1a: {
      value: "pastEducation_1a",
      label: "Describe the problem",
    },
    pastEducation_2: {
      value: "pastEducation_2",
      label: "Social situations",
    },
    pastEducation_2a: {
      value: "pastEducation_2a",
      label: "Describe the problem",
    },
    pastEducation_3: {
      label: "Taking tests",
      value: "pastEducation_3",
    },
    pastEducation_3a: {
      value: "pastEducation_3a",
      label: "Describe the problem",
    },
    pastEducation_4: {
      label: "Learning from lectures",
      value: "pastEducation_4",
    },
    pastEducation_4a: {
      value: "pastEducation_4a",
      label: "Describe the problem",
    },
    pastEducation_5: {
      label: "Learning by reading",
      value: "pastEducation_5",
    },
    pastEducation_5a: {
      value: "pastEducation_5a",
      label: "Describe the problem",
    },
    pastEducation_6: {
      label: "Learning hands on",
      value: "pastEducation_6",
    },
    pastEducation_6a: {
      value: "pastEducation_6a",
      label: "Describe the problem",
    },
    pastEducation_7: {
      label: "Concentrating",
      value: "pastEducation_7",
    },
    pastEducation_7a: {
      value: "pastEducation_7a",
      label: "Describe the problem",
    },
    pastEducation_8: {
      label: "Memory and Recall",
      value: "pastEducation_8",
    },
    pastEducation_8a: {
      value: "pastEducation_8a",
      label: "Describe the problem",
    },
    pastEducation_9: {
      label: "Using computers",
      value: "pastEducation_9",
    },
    pastEducation_9a: {
      value: "pastEducation_9a",
      label: "Describe the problem",
    },
    pastEducation_10: {
      label:
        "Did you have an IEP (individual education plan) while you were in school?",
      value: "pastEducation_10",
    },
    pastEducation_10a: {
      label: "Did that include different strategies to help you learn?",
      value: "pastEducation_10a",
    },
    pastEducation_10b: {
      label: "What were those strategies?",
      value: "pastEducation_10b",
    },
    pastEducation_11: {
      label:
        "Please describe any advanced classes that you took while in school",
      value: "pastEducation_11",
    },
    pastEducation_12: {
      label: "Has anyone ever told you that you had a learning disability?",
      value: "pastEducation_12",
    },
    pastEducation_12a: {
      label: "What do you know about that disability?",
      value: "pastEducation_12a",
    },
    pastEducation_12b: {
      label: "What accomodations have helped you with learning in the past?",
      value: "pastEducation_12b",
    },
    pastEducation_13: {
      label: "What are your strengths related to being a student?",
      value: "pastEducation_13",
    },
    pastEducation_14: {
      label: "What languages do you know?",
      value: "pastEducation_14",
      skip: true,
    },
    pastEducation_14a: {
      label: "Other languages",
      value: "pastEducation_14a",
      skip: true,
    },
  },
  plansForSchoolAndTraining: {
    title: "Plans for school and training",
    index: 3,
    plansForSchool_1: {
      value: "plansForSchool_1",
      label:
        "What do you need in order to start school? (Select all that apply)",
      skip: true,
    },
    plansForSchool_1a: {
      value: "plansForSchool_1a",
      label: "What other needs?",
    },
    plansForSchool_2: {
      value: "plansForSchool_2",
      label:
        "Please provide any additional clarifcation or comments of items selected above:",
    },
    plansForSchool_3: {
      label:
        "What are you resources for paying for school tuition, for books, or other training/school costs?",
      value: "plansForSchool_3",
    },
    plansForSchool_4: {
      label: "Have you ever received financial aid for school?",
      value: "plansForSchool_4",
    },
    plansForSchool_4a: {
      label:
        "Please describe any grants or financial aid you have previously received (type and for what)",
      value: "plansForSchool_4a",
    },
    plansForSchool_4b: {
      label: "Have you ever defaulted on a grant or student loan?",
      value: "plansForSchool_4b",
    },
    plansForSchool_5: {
      label: "Please describe any type of classroom accomodations you may need",
      value: "plansForSchool_5",
    },
    plansForSchool_6: {
      label:
        "Please describe any other types of supports that may help you succeed in school or training",
      value: "plansForSchool_6",
    },
  },
  workExperience: {
    title: "Work experience",
    index: 4,
    workExperience_1: {
      label: "Have you ever had a job?",
      value: "hadJob_1",
    },
  },
  militaryExperience: {
    title: "Military experience",
    index: 5,
    militaryExperience_1: {
      label: "Have you ever been in the military?",
      value: "military_1",
    },
    militaryExperience_2: {
      label: "Branch",
      value: "military_2",
    },
    militaryExperience_3: {
      label: "Start Date",
      value: "military_3",
      type: "date",
    },
    militaryExperience_4: {
      label: "Discharge Date",
      value: "military_4",
      type: "date",
    },
    militaryExperience_5: {
      label: "Training or work experience",
      value: "military_5",
    },
    militaryExperience_6: {
      label: "Certificates or licenses obtained",
      value: "military_6",
    },
  },
  culturalBackground: {
    title: "Cultural background",
    index: 6,
    culturalBackground_1: {
      label:
        "What is important to you in terms of your background and culture?",
      subLabel: "Race, ethnicity, color, gender, economic status, etc.",
      value: "cultural_1",
    },
    culturalBackground_2: {
      label:
        "Which different languages do you speak? Which language do you prefer?",
      value: "cultural_2",
    },
    culturalBackground_3: {
      label:
        "What special events or holidays do you celebrate? Are there family traditions that you still practice?",
      value: "cultural_3",
    },
    culturalBackground_4: {
      label:
        "How would you like your family involved as we move forward in the process of getting and keeping a job?",
      value: "cultural_4",
    },
    culturalBackground_5: {
      label:
        "If you have ever felt discriminated against or treated unfairly when you were looking for work or on the job, can you describe that?",
      value: "cultural_5",
    },
  },
  mentalHealth: {
    title: "Mental health",
    index: 7,
    mentalHealth_1: {
      label:
        "Has anyone ever told you that you have a mental illness? If so, what did they say?",
      value: "mental_1",
    },
    mentalHealth_2: {
      label: "How does your mental illness affect you?",
      value: "mental_2",
    },
    mentalHealth_3: {
      label:
        "What are the first signs that you may be experiencing a symptom flare-up?",
      value: "mental_3",
    },
    mentalHealth_4: {
      label: "How do you cope with your symptoms?",
      value: "mental_4",
    },
    mentalHealth_5: {
      label: "What medicines do you take and when do you take them?",
      value: "mental_5",
    },
    mentalHealth_6: {
      label: "How do the medicines work for you?",
      value: "mental_6",
    },
  },
  substanceUse: {
    title: "Substance use",
    index: 8,
    substanceUse_1: {
      label: "How much alcohol do you drink?",
      value: "substanceUse_1",
    },
    substanceUse_2: {
      label:
        "How often do you drink alcohol? Is there a particular time of day you tend to drink?",
      value: "substanceUse_2",
    },
    substanceUse_3: {
      label: "What substances do you, or have you, used?",
      value: "substanceUse_3",
    },
    substanceUse_4: {
      label: "How often do you, or have you, used these substances?",
      value: "substanceUse_4",
    },
  },
  physicalHealth: {
    title: "Physical health",
    index: 9,
    physicalHealth_1: {
      label: "How would you describe your physical health?",
      value: "physical_1",
    },
    physicalHealth_2: {
      label:
        "Do you have any physical health problems? If so, can you describe them?",
      value: "physical_2",
    },
    physicalHealth_3: {
      label: "Standing for long periods of time?",
      value: "physical_3",
    },
    physicalHealth_4: {
      label: "Can you stand for more than an hour?",
      value: "physical_4",
    },
    physicalHealth_5: {
      label: "Sitting?",
      value: "physical_5",
    },
    physicalHealth_6: {
      label: "How long can you sit?",
      value: "physical_6",
    },
    physicalHealth_7: {
      label: "Climbing stairs?",
      value: "physical_7",
    },
    physicalHealth_8: {
      label: "How many flights of stairs can you climb and how often?",
      value: "physical_8",
    },
    physicalHealth_9: {
      label: "Lifting?",
      value: "physical_9",
    },
    physicalHealth_10: {
      label: "How many pounds can you lift?",
      value: "physical_10",
    },
    physicalHealth_11: {
      label: "Endurance?",
      value: "physical_11",
    },
    physicalHealth_12: {
      label: "How many hours could you work each day?",
      value: "physical_12",
    },
    physicalHealth_13: {
      label: "How many hours could you work each week?",
      value: "physical_13",
    },
    physicalHealth_14: {
      label:
        "What is the best time of day for you in terms of how your physical health?",
      value: "physical_14",
    },
  },
  cognitiveHealth: {
    title: "Cognitive health",
    index: 10,
    cognitiveHealth_1: {
      label: "Do you have problems with memory? If so, can you describe these?",
      value: "cognitive_1",
    },
    cognitiveHealth_2: {
      label:
        "Do you have problems concentrating? If so, can you describe these?",
      value: "cognitive_2",
    },
    cognitiveHealth_3: {
      label:
        "Do you have problems doing things fast (psychomotor speed)? If so, can you describe these?",
      value: "cognitive_3",
    },
    cognitiveHealth_4: {
      label: "What things have helped with any of these issues in the past?",
      value: "cognitive_4",
    },
  },
  gettingReadyJob: {
    title: "Getting ready for a job",
    index: 11,
    gettingReadyForJob_1: {
      label:
        "Do you have the clothes you will need for interviews and a potential job?",
      value: "readyJob_1",
    },
    gettingReadyForJob_2: {
      label: "Do you have an alarm clock or way to wake up for work?",
      value: "readyJob_2",
    },
    gettingReadyForJob_3: {
      label: "Do you have two forms of identification?",
      value: "readyJob_3",
    },
    gettingReadyForJob_4: {
      label: "Do you have a way to get to work consitently that is reliable?",
      value: "readyJob_4",
    },
  },
  interpersonalSkills: {
    title: "Interpersonal skills",
    index: 12,
    interpersonalSkills_1: {
      label: "Would you like a job that involved working with the public?",
      value: "interpersonalSkills_1",
    },
    interpersonalSkills_2: {
      label: "Where do you live and with whom do you live?",
      value: "interpersonalSkills_2",
    },
    interpersonalSkills_3: {
      label:
        "Who do you spend time with? How often do you see or talk to them?",
      value: "interpersonalSkills_3",
    },
    interpersonalSkills_4: {
      label: "Who can help us think about jobs you would enjoy?",
      value: "interpersonalSkills_4",
    },
    interpersonalSkills_5: {
      label:
        "Once you are employed, who would be a good person to support you?",
      value: "interpersonalSkills_5",
    },
  },
  benefits: {
    title: "Benefits",
    index: 13,
    benefits_received: {
      label: "Please select any of the following benefits you receive:",
      value: "benefits_received",
    },
    benefits_received_other: {
      label: "Other benefits",
      value: "benefits_received_other",
    },
    benefits_1: {
      label:
        "Does your spouse/partner or any of your dependents receive any of these benefits?",
      value: "benefits_1",
    },
    benefits_2: {
      label: "Do you manage your own money?",
      value: "benefits_2",
    },
    benefits_3: {
      label: "Would you like a referral to a benefits manager?",
      value: "benefits_3",
    },
  },
  legalHistory: {
    title: "Legal history",
    index: 14,
    legalHistory_1: {
      label: "Have you ever been arrested?",
      value: "legal_1",
    },
    legalHistory_2: {
      label: "Do you have any pending legal charges? If so, what are they?",
      value: "legal_2",
    },
    legalHistory_3: {
      label: "Are you currently on probation/parole?",
      value: "legal_3",
    },
    legalHistory_3a: {
      label: "Officer name",
      value: "legal_3a",
    },
    legalHistory_3b: {
      label: "Officer phone number",
      value: "legal_3b",
    },
    legalHistory_3c: {
      label: "Officer email",
      value: "legal_3c",
    },
    legalHistory_4: {
      label:
        "Do you have a copy of your criminal history record (i.e., rap sheet)?",
      value: "legal_4",
    },
    legalHistory_4a: {
      label: "Would you like to get a copy of your criminal history record?",
      value: "legal_4a",
    },
    legalHistory_convictions: {
      label: "",
      value: "legal_convictions",
      skip: true,
    },
  },
  dailyActivities: {
    title: "Daily activities",
    index: 15,
    dailyActivities_1: {
      label:
        "What is a typical day like for you from the time you get up until you go to bed?",
      value: "daily_1",
    },
    dailyActivities_2: {
      label: "What places in your neighborhood do you like to go to?",
      value: "daily_2",
    },
    dailyActivities_3: {
      label: "What clubs, groups, churches, etc. do you belong to?",
      value: "daily_3",
    },
    dailyActivities_4: {
      label: "What hobbies or interests do you have?",
      value: "daily_4",
    },
    dailyActivities_5: {
      label: "What are your typical sleep hours/patterns?",
      value: "daily_5",
    },
  },
  networkingContacts: {
    title: "Networking contacts and info",
    index: 16,
    networkingContacts_1: {
      label:
        "Any other information about or from family, previous employers, or others that you would like to include?",
      value: "networking_1",
    },
  },
}
